<template>
  <v-html-panel></v-html-panel>
</template>
<style scoped></style>
<script>
  import vHtmlPanel from '@/components/HtmlPanel/htmlPanel';
  // import { mapState } from 'vuex';
  export default {
    name: 'htmlViewSample',
    data() {
      return {};
    },
    components: {
      vHtmlPanel,
    },
    created() {},
    methods: {},
  };
</script>
